import { formatMoeda, formatTaxa } from "../../planejamento-controle.format";
import {
  COTACAO_DESTINO_TEXTO,
  ESCOPO_TRANSFERIDO_LABEL,
  NOVO_TOTAL_LABEL,
  SEM_COTACAO_ALERTA,
  SEM_PROJECAO,
  SEM_TOTAL,
  TOTAL_ATUAL_LABEL,
} from "./cartao-financeiro-transferencia.constants";
import type { CartaoFinanceiroTransferenciaProps } from "./types-cartao-financeiro-transferencia";

const reais = (valor: number) => formatMoeda(valor, "BRL");

export function useCartaoFinanceiroTransferencia({
  estado,
  errorMessage,
  recarregar,
  previa,
  totalAtualTipo,
  tipoObra,
  escopoNome,
  obraDestino,
}: CartaoFinanceiroTransferenciaProps) {
  const projecao = previa?.projecao ?? null;
  const transferido = projecao?.totalDestino ?? null;
  const novoTotal = totalAtualTipo === null ? null : totalAtualTipo + (transferido ?? 0);
  const cotacao = projecao?.cotacaoDestino ?? null;

  return {
    estado,
    errorMessage,
    recarregar,
    valores: [
      {
        chave: "atual",
        testId: "transferir-financeiro-atual",
        rotulo: TOTAL_ATUAL_LABEL(tipoObra),
        valor: totalAtualTipo === null ? SEM_TOTAL : reais(totalAtualTipo),
      },
      {
        chave: "transferido",
        testId: "transferir-financeiro-transferido",
        rotulo: ESCOPO_TRANSFERIDO_LABEL,
        valor: transferido === null ? SEM_PROJECAO : reais(transferido),
      },
      {
        chave: "novo",
        testId: "transferir-financeiro-novo",
        rotulo: NOVO_TOTAL_LABEL(tipoObra),
        valor: novoTotal === null ? SEM_TOTAL : reais(novoTotal),
      },
    ],
    cotacao: cotacao
      ? COTACAO_DESTINO_TEXTO(obraDestino, cotacao.moeda, formatTaxa(cotacao.valor))
      : null,
    alertasCotacao: (previa?.moedasSemCotacao ?? []).map(({ moeda, escopo }) =>
      SEM_COTACAO_ALERTA(obraDestino, moeda, escopo || escopoNome),
    ),
  };
}
